import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import cn from "clsx";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./index.module.scss";
import OrderIcon from "@/assets/icons/OrderIcon.svg";
import VoucherIcon from "@/assets/icons/VoucherIcon.svg";
import ReviewIcon from "@/app/csr-src/assets/icons/ReviewIcon.svg";
import WishIcon from "@/assets/icons/WishIcon.svg";
import AddressIcon from "@/assets/icons/AddressIcon.svg";
import HistoryIcon from "@/assets/icons/HistoryIcon2.svg";
import ReturnIcon from "@/app/csr-src/assets/icons/ReturnIcon.svg";

export interface SideMenuHandle {
  updateData: () => void;
}
interface SideMenuProps {
  orderNum?: number;
  messageNum?: number;
  couponsNum?: number;
}

const SideMenu = forwardRef<SideMenuHandle, SideMenuProps>(function SideMenu(props, ref) {
  const { orderNum = 0, messageNum = 0, couponsNum = 0 } = props;
  const { t } = useTranslation();

  const location = useLocation();
  const navigate = useNavigate();

  const [menuList, setMenuList] = useState([
    {
      key: "order",
      name: t("common.pageName.myOrders"),
      ico: <OrderIcon className={styles.menu_ico} width={16} height={16} />,
      path: "/profile/my-orders",
    },
    {
      key: "returns",
      name: t("common.pageName.returns"),
      ico: <ReturnIcon className={styles.menu_ico} width={16} height={16} />,
      path: "/profile/my-returns",
    },
    {
      key: "coupons",
      name: t("common.pageName.coupons"),
      ico: <VoucherIcon className={styles.menu_ico} width={16} height={16} />,
      path: "/profile/coupons-discounts",
    },
    {
      name: t("common.pageName.myReviews"),
      ico: <ReviewIcon className={styles.menu_ico} width={16} height={16} />,
      path: "/profile/my-reviews",
    },
    {
      name: t("common.pageName.wishlist"),
      ico: <WishIcon className={styles.menu_ico} width={16} height={16} />,
      path: "/profile/wishlist",
    },
    {
      name: t("common.pageName.addresses"),
      path: "/profile/my-address",
      ico: <AddressIcon className={styles.menu_ico} width={16} height={16} />,
    },
    {
      name: t("common.pageName.browsingHistory"),
      ico: <HistoryIcon className={styles.menu_ico} width={16} height={16} />,
      path: "/profile/shopping-activity",
    },
  ]);
  const getNumber = (key: string) => {
    let num: number;
    switch (key) {
      case "order":
        num = orderNum;
        break;
      case "message":
        num = messageNum;
        break;
      case "coupons":
        num = couponsNum;
        break;
      default:
        num = 0;
    }
    return num > 99 ? "99+" : num === 0 ? "" : num;
  };
  return (
    <div className={styles.wrap}>
      {menuList.map((item, index) => {
        const isActive = item.path === location.pathname.toLowerCase();
        return (
          <div
            key={index}
            className={cn(styles.menu_item_wrap, { [styles.active_menu_item_wrap]: isActive })}
            onClick={() => {
              navigate(item.path);
            }}
          >
            <div className={styles.menu_item}>
              {/* <img src={isActive ? item.activeIco : item.ico} alt="ico" /> */}
              {item.ico}
              {item.name}
            </div>
            {item.key ? <div className={styles.item_desc}>{getNumber(item.key)}</div> : null}
          </div>
        );
      })}
    </div>
  );
});

export default observer(SideMenu);
